import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/manual/i18n/scope";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../../api-spec";

@Component({
    selector: "app-task-update-task-hyperlink-api-manual",
    templateUrl: "../../../api-spec.html",
    styleUrls: ["../../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class TaskUpdateTaskHyperlinkApiManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: this.translation.t("tableOfContents.addHyperlinkToTask"),
            description: this.translation.t("specs.addHyperlinkToTaskDescription"),
            httpMethod: "POST",
            path: "/taskdata/v1/tasks/{guid}/add/hyperlink",

            parameters: [
                {
                    name: "guid",
                    description: this.translation.t("parameters.addHyperlinkToTaskGuidDescription"),
                    in: "path",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "name",
                    description: this.translation.t("parameters.taskNameDescription"),
                    in: "body",
                    paramType: "string",
                    required: true,
                    example: "hyperlink name",
                },
                {
                    name: "hyperlink",
                    description: this.translation.t("parameters.addHyperlinkToTaskHyperlinkDescription"),
                    in: "body",
                    paramType: "string",
                    required: true,
                    example: "https://www.example.com",
                },
                {
                    name: "description",
                    description: this.translation.t("parameters.taskDescriptionDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "hyperlink description",
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                },
            ],
        };
    }
}
